export default __webpack_public_path__ + "images/goal-cc1eb.svg";